import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core.component';
import { MatButtonModule } from '@angular/material/button';
import { ImageThumbService } from '../app-shared/services/image-thumb.service';
import { OutletStorageService } from '../app-shared/services/outlet-storage.service';
import { LazyLoadingModulesModule } from '../app-shared/directives/lazy-loading-modules.module';
import { MobileGuard } from '../app-shared/services/mobile.guard';
import { DraftCartService } from '../app-shared/services/draft-cart.service';
import { LoaderModule } from '../app-shared/components/loader/loader.module';
import { OrderHistoryService } from '../order-history/order-shared/services/order-history.service';
import { HeaderModule } from './header/header.module';
import { CommonModule } from '@angular/common';
import { AddNewCategoryDialogsModule } from './add-new-category-dialogs/add-new-category-dialogs.module';
import { AppSharedModule } from '../app-shared/app-shared.module';
import {GeneralMessageModule} from "../app-shared/components/general-message/general-message.module";
import {FooterModule} from "./footer/footer.module";
import {CartWidgetPreviewModule} from "./cart-widget-preview/cart-widget-preview.module";
import { FeedbackModule } from '../feedback/feedback.module';
import {UserNotificationModule} from "./user-notification/user-notification.module";

@NgModule({
  declarations: [CoreComponent],
    imports: [
        CommonModule,
        RouterModule,
        CoreRoutingModule,
        MatButtonModule,
        LazyLoadingModulesModule,
        LoaderModule,
        HeaderModule,
        AddNewCategoryDialogsModule,
        GeneralMessageModule,
        AppSharedModule,
        FooterModule,
        CartWidgetPreviewModule,
        FeedbackModule,
        UserNotificationModule
    ],
  providers: [
    ImageThumbService,
    OutletStorageService,
    DraftCartService,
    MobileGuard,
    OrderHistoryService,
  ],
})
export class CoreModule { }
